import * as React from 'react';
import Slider from 'react-rangeslider';
import 'react-rangeslider/lib/index.css';
import './Selector.css';


export interface ISelectorProps {
  label: string;
  value: number;
  show: boolean;
  unit: string;
  step: number;
  minValue: number;
  maxValue: number;
  onCloseClick: (event: React.MouseEvent<HTMLDivElement>) => void;
  // onUpClick: (event: React.MouseEvent<HTMLDivElement>) => void;
  // onDownClick: (event: React.MouseEvent<HTMLDivElement>) => void;
  onChange?(value: number): void;
}

declare var Waves: any;

class Selector extends React.Component<ISelectorProps, object> {

  public constructor(props: ISelectorProps) {
    super(props);
  }

  public componentDidMount() {
    Waves.attach('div.buttonDown', 'waves-light');
    Waves.attach('div.buttonUp', 'waves-light');

  }

  public dummyClick(event: React.MouseEvent<HTMLDivElement>) {
    event.stopPropagation();
  }

  public componentDidUpdate() {
    if (document.getElementById("fakeImg") != null) {
      document.getElementById("fakeImg")!.focus();
    }
    // this.setState({ size: this.state.size === 150 ? 140 : 150 });
    if (document.getElementById("selector") != null) {
      document.getElementById("selector")!.style.display = "none";
      document.getElementById("selector")!.style.display = "flex";
    }

  }

  public render() {
    const { label, maxValue, minValue, onCloseClick, show, step, value, onChange } = this.props;
    // label, value, onUpClick, onDownClick,
    if (!show) {
      return null;
    }

    const formatedValue = value && value.toFixed(1) + ' ' + this.props.unit;



    return (

      <div onClick={onCloseClick} className="selectorInvisibleBackground" >
        <img id="fakeImg" tabIndex={1} height="0px" width="0px" />
        <div id="selector" className="selector" onClick={this.dummyClick}  >
          <div className="title">
            <span>{label}</span>
          </div>
          <div className="value">
            {formatedValue}
          </div>
          <div className="data">
            <Slider
              min={minValue}
              max={maxValue}
              step={step}
              tooltip={false}
              value={value}
              onChange={onChange}
            />
          </div>
        </div >
      </div >

    );
  }
}

export default Selector;


// WEBPACK FOOTER //
// ./src/components/Selector.tsx